import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import * as Constants from '../../constants';
import HelpIcon from '@mui/icons-material/Help';
import ModalWithCard from '../../items/ModalWithCard.js';

const Statistic = ({ event, getToken, userdata }) => {
  const { t, i18n } = useTranslation();
  const [statData, setstatData] = React.useState([]);
  const [showRebootRnsModal, setRebootRnsModal] = useState(false);
  const [rebootReasons, setRebootReasons] = useState([]);

  useEffect(() => {
    const get = async () => {
      await getStatData();
    };
    get();
  }, []);

  //запрос данных
  const getStatData = async () => {
    const token = getToken();
    if (token) {
      const bearer = {
        //params: { online: false }, query
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/telemetry/devlist', bearer)
        .then((res) => {
          setstatData(res.data);
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  const showReasons = async (dev) => {
    setRebootReasons(dev.rebootreason);
    setRebootRnsModal(true);
  };

  return (
    <>
      {statData ? (
        <div className='overflow-x-auto mt-4'>
          <table className='table text-gray-90'>
            {/* head */}
            <thead className='text-gray-600'>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {/* rows */}

              {statData.map((dev, cIndex) => (
                <>
                  <tr
                    class={
                      dev.rebootreason.toString().includes('Watchdog') ||
                      dev.rebootreason.toString().includes('Exception')
                        ? 'bg-red-50'
                        : ''
                    }
                    key={cIndex}>
                    <td class='p-1'>{cIndex + 1}</td>
                    <td class='p-1'>
                      <img
                        class='h-5 w-8 border border-gray-500 shadow-xl dark:shadow-gray-800'
                        src={dev.location.country_flag}></img>{' '}
                    </td>
                    <td class='p-1'>{dev.location.country_name + ' ' + dev.location.city}</td>
                    <td class='p-1'>{dev.nameesp}</td>
                    <td class='p-1'>{dev.idesp}</td>
                    <td class='p-1'>{dev.firmwarename}</td>
                    <td class='p-1'>{dev.firmwarever}</td>
                    <td class='p-1'>{dev.uptime}</td>

                    <td class='p-1'>
                      {new Date(dev.lastContacted).toLocaleString('ru', {
                        timeZone: 'Europe/Vienna',
                      })}
                    </td>

                    <td class='p-1'>
                      {dev.online ? (
                        <div className='badge badge-accent'>online</div>
                      ) : (
                        <div className='badge badge-ghost'>offline</div>
                      )}
                    </td>
                    <td class='p-1'>
                      <div onClick={() => showReasons(dev)}>
                        <HelpIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></HelpIcon>
                      </div>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div class='flex items-center justify-center'>
          <span className='loading loading-dots loading-lg'></span>
        </div>
      )}
      {showRebootRnsModal && (
        <ModalWithCard setShowModal={setRebootRnsModal}>
          {rebootReasons.map((reason, i) => (
            <p>{reason}</p>
          ))}
        </ModalWithCard>
      )}
    </>
  );
};

export default Statistic;
